// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.asset-subtitle-list {
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;

    overflow: hidden;
    box-sizing: border-box;
}

/* -------------------------------- */
/* Barre de titre                   */
/* -------------------------------- */

.asset-subtitle-list-header {
    flex-shrink: 0;

    display: grid;

    grid-template-columns:
        80px
        100px
        minmax(0, 1fr)
        70px
        70px
        30px;

    height: 30px;

    align-items: center;

    background: transparent;
    color: var(--default-icon-color);

    font-weight: bold;
    font-size: 13px;

    box-sizing: border-box;
}

.asset-subtitle-list-header > div {
    padding: 0 6px;
    box-sizing: border-box;
}

/* -------------------------------- */
/* Liste scrollable                 */
/* -------------------------------- */

.asset-subtitle-list-content {

    height: 150px;
    overflow-y: auto;
    overflow-x: hidden;

    /* Firefox */
    scrollbar-width: none;

    /* IE / anciennes versions Edge */
    -ms-overflow-style: none;
}

/* Chrome / Edge / Safari */
.asset-subtitle-list-content::-webkit-scrollbar {
    display: none;
}

/* -------------------------------- */
/* Lignes                           */
/* -------------------------------- */

.asset-subtitle-list-row {
    display: grid;

    grid-template-columns:
        80px
        100px
        minmax(0, 1fr)
        70px
        70px
        30px;

    min-height: 30px;

    align-items: center;

    font-size: 13px;

    box-sizing: border-box;
}

.asset-subtitle-list-row-alt {
    background: #181818;
}

.asset-subtitle-list-row:hover {
    background: #505050;
}

.asset-subtitle-list-row > div {
    padding: 0 6px;
    box-sizing: border-box;
}

/* -------------------------------- */
/* Colonnes                         */
/* -------------------------------- */

.asset-subtitle-col-asset {
    text-align: right;
}

.asset-subtitle-col-type {
    text-align: left;
}

.asset-subtitle-col-title {
    text-align: left;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.asset-subtitle-col-start,
.asset-subtitle-col-end {
    text-align: center;
}

/* -------------------------------- */
/* Inputs                           */
/* -------------------------------- */

.asset-subtitle-col-start input,
.asset-subtitle-col-end input {
    width: 55px;
    height: 22px;

    padding: 2px 4px;

    box-sizing: border-box;

    text-align: center;

    border: 1px solid #aaa;
    border-radius: 4px;
    font-size: 13px;
    color: white;
}

/* Supprime les flèches Chrome/Edge */
.asset-subtitle-col-start input::-webkit-outer-spin-button,
.asset-subtitle-col-start input::-webkit-inner-spin-button,
.asset-subtitle-col-end input::-webkit-outer-spin-button,
.asset-subtitle-col-end input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
.asset-subtitle-col-start input[type=number],
.asset-subtitle-col-end input[type=number] {
    -moz-appearance: textfield;
}

/* -------------------------------- */
/* Bouton -                        */
/* -------------------------------- */

.asset-subtitle-col-button {
    display: flex;

    align-items: center;
    justify-content: center;
}

.asset-subtitle-remove-button {
    width: 20px;
    height: 20px;

    padding: 0;
    margin: 0;

    border: 1px solid #888;
    border-radius: 3px;

    background: var(--default-icon-color);
    color: #333;

    font-size: 16px;
    line-height: 16px;

    cursor: pointer;
}

.asset-subtitle-remove-button:hover {
    background: #ddd;
}

.asset-subtitle-remove-button:active {
    background: #bbb;
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/appmediaassets/mergedialog/assetsubtitleselection/assetsubtitleselection.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,sBAAsB;;IAEtB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,qCAAqC;AACrC,qCAAqC;AACrC,qCAAqC;;AAErC;IACI,cAAc;;IAEd,aAAa;;IAEb;;;;;;YAMQ;;IAER,YAAY;;IAEZ,mBAAmB;;IAEnB,uBAAuB;IACvB,gCAAgC;;IAEhC,iBAAiB;IACjB,eAAe;;IAEf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA,qCAAqC;AACrC,qCAAqC;AACrC,qCAAqC;;AAErC;;IAEI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;;IAElB,YAAY;IACZ,qBAAqB;;IAErB,iCAAiC;IACjC,wBAAwB;AAC5B;;AAEA,2BAA2B;AAC3B;IACI,aAAa;AACjB;;AAEA,qCAAqC;AACrC,qCAAqC;AACrC,qCAAqC;;AAErC;IACI,aAAa;;IAEb;;;;;;YAMQ;;IAER,gBAAgB;;IAEhB,mBAAmB;;IAEnB,eAAe;;IAEf,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA,qCAAqC;AACrC,qCAAqC;AACrC,qCAAqC;;AAErC;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;;IAEhB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA,qCAAqC;AACrC,qCAAqC;AACrC,qCAAqC;;AAErC;;IAEI,WAAW;IACX,YAAY;;IAEZ,gBAAgB;;IAEhB,sBAAsB;;IAEtB,kBAAkB;;IAElB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA,qCAAqC;AACrC;;;;IAII,wBAAwB;IACxB,SAAS;AACb;;AAEA,YAAY;AACZ;;IAEI,0BAA0B;AAC9B;;AAEA,qCAAqC;AACrC,oCAAoC;AACpC,qCAAqC;;AAErC;IACI,aAAa;;IAEb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,UAAU;IACV,SAAS;;IAET,sBAAsB;IACtB,kBAAkB;;IAElB,qCAAqC;IACrC,WAAW;;IAEX,eAAe;IACf,iBAAiB;;IAEjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["\n.asset-subtitle-list {\n    width: 100%;\n    height: 100%;\n\n    display: flex;\n    flex-direction: column;\n\n    overflow: hidden;\n    box-sizing: border-box;\n}\n\n/* -------------------------------- */\n/* Barre de titre                   */\n/* -------------------------------- */\n\n.asset-subtitle-list-header {\n    flex-shrink: 0;\n\n    display: grid;\n\n    grid-template-columns:\n        80px\n        100px\n        minmax(0, 1fr)\n        70px\n        70px\n        30px;\n\n    height: 30px;\n\n    align-items: center;\n\n    background: transparent;\n    color: var(--default-icon-color);\n\n    font-weight: bold;\n    font-size: 13px;\n\n    box-sizing: border-box;\n}\n\n.asset-subtitle-list-header > div {\n    padding: 0 6px;\n    box-sizing: border-box;\n}\n\n/* -------------------------------- */\n/* Liste scrollable                 */\n/* -------------------------------- */\n\n.asset-subtitle-list-content {\n\n    height: 150px;\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    /* Firefox */\n    scrollbar-width: none;\n\n    /* IE / anciennes versions Edge */\n    -ms-overflow-style: none;\n}\n\n/* Chrome / Edge / Safari */\n.asset-subtitle-list-content::-webkit-scrollbar {\n    display: none;\n}\n\n/* -------------------------------- */\n/* Lignes                           */\n/* -------------------------------- */\n\n.asset-subtitle-list-row {\n    display: grid;\n\n    grid-template-columns:\n        80px\n        100px\n        minmax(0, 1fr)\n        70px\n        70px\n        30px;\n\n    min-height: 30px;\n\n    align-items: center;\n\n    font-size: 13px;\n\n    box-sizing: border-box;\n}\n\n.asset-subtitle-list-row-alt {\n    background: #181818;\n}\n\n.asset-subtitle-list-row:hover {\n    background: #505050;\n}\n\n.asset-subtitle-list-row > div {\n    padding: 0 6px;\n    box-sizing: border-box;\n}\n\n/* -------------------------------- */\n/* Colonnes                         */\n/* -------------------------------- */\n\n.asset-subtitle-col-asset {\n    text-align: right;\n}\n\n.asset-subtitle-col-type {\n    text-align: left;\n}\n\n.asset-subtitle-col-title {\n    text-align: left;\n\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n.asset-subtitle-col-start,\n.asset-subtitle-col-end {\n    text-align: center;\n}\n\n/* -------------------------------- */\n/* Inputs                           */\n/* -------------------------------- */\n\n.asset-subtitle-col-start input,\n.asset-subtitle-col-end input {\n    width: 55px;\n    height: 22px;\n\n    padding: 2px 4px;\n\n    box-sizing: border-box;\n\n    text-align: center;\n\n    border: 1px solid #aaa;\n    border-radius: 4px;\n    font-size: 13px;\n    color: white;\n}\n\n/* Supprime les flèches Chrome/Edge */\n.asset-subtitle-col-start input::-webkit-outer-spin-button,\n.asset-subtitle-col-start input::-webkit-inner-spin-button,\n.asset-subtitle-col-end input::-webkit-outer-spin-button,\n.asset-subtitle-col-end input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Firefox */\n.asset-subtitle-col-start input[type=number],\n.asset-subtitle-col-end input[type=number] {\n    -moz-appearance: textfield;\n}\n\n/* -------------------------------- */\n/* Bouton -                        */\n/* -------------------------------- */\n\n.asset-subtitle-col-button {\n    display: flex;\n\n    align-items: center;\n    justify-content: center;\n}\n\n.asset-subtitle-remove-button {\n    width: 20px;\n    height: 20px;\n\n    padding: 0;\n    margin: 0;\n\n    border: 1px solid #888;\n    border-radius: 3px;\n\n    background: var(--default-icon-color);\n    color: #333;\n\n    font-size: 16px;\n    line-height: 16px;\n\n    cursor: pointer;\n}\n\n.asset-subtitle-remove-button:hover {\n    background: #ddd;\n}\n\n.asset-subtitle-remove-button:active {\n    background: #bbb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
